import React, { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusRejectedIcon: FC<IconProps> = (props) => {
  const theme = useTheme();
  return (
    <Icon height="24px" {...props} viewBox="0 0 34 33">
      <circle
        opacity="0.1"
        cx="17.375"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <g clipPath="url(#clip0_7868_65370)">
        <path
          d="M22.2705 11.8242C21.9631 11.8242 21.7139 11.575 21.7139 11.2676V7H13.7354C12.8146 7 12.0654 7.74913 12.0654 8.66992V14.8928C12.2488 14.8761 12.4344 14.8672 12.6221 14.8672C14.5194 14.8672 16.2179 15.7347 17.3419 17.0938H23.3838C23.6912 17.0938 23.9404 17.343 23.9404 17.6504C23.9404 17.9578 23.6912 18.207 23.3838 18.207H18.0752C18.4232 18.886 18.6475 19.6382 18.7195 20.4336H23.3838C23.6912 20.4336 23.9404 20.6828 23.9404 20.9902C23.9404 21.2976 23.6912 21.5469 23.3838 21.5469H18.7195C18.5531 23.3852 17.5709 24.9916 16.1385 26H24.8682C25.789 26 26.5381 25.2509 26.5381 24.3301V11.8242H22.2705ZM23.3838 14.8672H15.2197C14.9123 14.8672 14.6631 14.618 14.6631 14.3105C14.6631 14.0031 14.9123 13.7539 15.2197 13.7539H23.3838C23.6912 13.7539 23.9404 14.0031 23.9404 14.3105C23.9404 14.618 23.6912 14.8672 23.3838 14.8672Z"
          fill={theme.colors.red}
        />
        <path
          d="M22.8271 7.32593V10.7109H26.2119L22.8271 7.32593Z"
          fill={theme.colors.red}
        />
        <path
          d="M12.6221 15.9805C9.85969 15.9805 7.6123 18.2278 7.6123 20.9902C7.6123 23.7526 9.85969 26 12.6221 26C15.3845 26 17.6318 23.7526 17.6318 20.9902C17.6318 18.2278 15.3845 15.9805 12.6221 15.9805ZM14.6856 22.2666C14.903 22.4839 14.903 22.8364 14.6856 23.0538C14.5769 23.1624 14.4345 23.2168 14.292 23.2168C14.1495 23.2168 14.0071 23.1624 13.8984 23.0537L12.6221 21.7774L11.3457 23.0538C11.2371 23.1624 11.0946 23.2168 10.9521 23.2168C10.8097 23.2168 10.6672 23.1624 10.5586 23.0537C10.3412 22.8364 10.3412 22.4839 10.5586 22.2665L11.8349 20.9902L10.5585 19.7139C10.3411 19.4965 10.3411 19.1441 10.5585 18.9267C10.7759 18.7093 11.1283 18.7093 11.3457 18.9267L12.6221 20.203L13.8984 18.9267C14.1158 18.7093 14.4682 18.7093 14.6856 18.9267C14.903 19.144 14.903 19.4965 14.6856 19.7139L13.4093 20.9902L14.6856 22.2666Z"
          fill={theme.colors.red}
        />
      </g>
      <defs>
        <clipPath id="clip0_7868_65370">
          <rect
            width="19"
            height="19"
            fill={theme.colors.white}
            transform="translate(7.5752 7)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
